import React from "react";

import * as ResourceHub from "components/ResourceHub";
import { ResourceHubItemType } from "modules/api/endpoints/resource-hub";

import * as styles from "./styles.module.scss";

type ResourceHubGridProps = {
  entries: ResourceHubItemType[] | null;
};

const Grid: React.FC<ResourceHubGridProps> = ({ entries }) => {
  return (
    <div className={styles.grid}>
      {entries && entries.length > 0 ? (
        <ul>
          {entries.map((entry: ResourceHubItemType) => {
            return (
              <li key={entry.id}>
                <ResourceHub.Post
                  contentType={entry?.contentType}
                  image={entry?.image}
                  id={entry?.id}
                  publicationDate={entry?.publicationDate}
                  timeToRead={entry?.timeToRead}
                  title={entry?.title}
                  url={entry?.url}
                />
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
};

export default Grid;
